export default __webpack_public_path__ + "static/media/Bg1.2e779b57.png";